import React, { useMemo, useRef } from 'react';
import { compose } from 'lodash/fp';
import ReactHtmlParser from 'react-html-parser';
import { CSSTransition } from 'react-transition-group';

import Box from '@rexlabs/box';
import { StyleSheet, styled } from '@rexlabs/styling';

import './styles.css';

const defaultStyles = StyleSheet({
  container: {
    zIndex: '999 !important',
    background: 'var(--brand_primary_color)',
    width: '100%',
    minWidth: '100px',
    position: 'fixed',
    padding: '0 25px',
    color: 'white'
  },
  content: {
    width: '100%'
  },
  close: {
    cursor: 'pointer',
    padding: '0 10px',
    fontSize: '2em'
  }
});

function BannerPopup({
  styles: s,
  popup,
  closeModal,
  showing,
  bgColor,
  textColor
}) {
  const ref = useRef();
  const position = popup?.position;
  const animation = useMemo(
    () => `banner-${position}-` + (popup?.animation ? popup.animation : 'none'),
    [popup]
  );

  const handleEnter = () => {
    const header = document.getElementById('header');
    if (header && position === 'top') {
      setTimeout(() => {
        header.style.marginTop = `${ref?.current?.offsetHeight ?? 0}px`;
      });
    }
  };

  const handleExit = () => {
    const header = document.getElementById('header');
    if (header && position === 'top') {
      header.style.marginTop = 0;
    }
  };

  return (
    <CSSTransition
      unmountOnExit
      in={showing}
      timeout={0}
      classNames={animation}
      onEnter={handleEnter}
      onExiting={handleExit}
    >
      <Box
        ref={ref}
        {...s.with('container')({
          background: bgColor,
          color: textColor,
          [position]: 0
        })}
        flexDirection='row'
        justifyContent='space-between'
      >
        <Box
          className={'popupContainer'}
          {...s('content')}
          flexDirection='row'
          justifyContent='center'
          alignItems='center'
        >
          <Box className='font-size-normal weight-bold' mr={8}>
            {popup?.title}
          </Box>
          <Box className='font-size-normal weight-medium'>
            {ReactHtmlParser(popup?.content)}
          </Box>
        </Box>
        <Box {...s('close')} alignItems='center' onClick={closeModal}>
          &times;
        </Box>
      </Box>
    </CSSTransition>
  );
}

const WrappedBannerPopup = compose(styled(defaultStyles))(BannerPopup);

export default WrappedBannerPopup;
